import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { ShipperEntity } from 'src/entities/shipperEntity';
import { fetchAllPages, PagedResult } from 'src/utils/fetchAllPages';

const buildRequestPath: (page: number, withData: boolean) => string = (
  page,
  withData
) => [`/api/v2/shippers?page=${page}`, withData ? 'with_data=1' : null].filter((maybe) => !!maybe).join('&');

const fetchShippersPage = async (page: number): Promise<PagedResult<ShipperEntity>> => {
  const response: AxiosResponse<{
    ids: number[],
    total_pages_count: number,
    data: ShipperEntity[],
  }> = await axios.get(buildRequestPath(page, true));

  return { items: response.data.data, totalPagesCount: response.data.total_pages_count };
};

export const useQueryShippers = (enabled: boolean) => useQuery({
  queryKey: ['shippers'],
  queryFn: () => fetchAllPages(fetchShippersPage),
  enabled,
  staleTime: Infinity,
  // 再試行は fetchAllPages がページ単位で行う。ここで retry すると
  // 成功済みのページまで取り直してしまうため無効化する。
  retry: false,
});
